import { Head } from "vike-react/Head";
import { useLanguage } from "@/i18n/LanguageContext";
import { usePageContext } from "vike-react/usePageContext";

interface SeoProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  type?: "website" | "article";
}

const SeoMetadata = ({ title, description, keywords, image, type = "website" }: SeoProps) => {
  const { language, t } = useLanguage();
  const pageContext = usePageContext();

  const domain = "https://fourleaves.pl";

  // Consistently remove the trailing slash for canonical URLs (except for the root domain)
  let path = pageContext.urlPathname || "/";
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }

  const currentUrl = `${domain}${path}`;

  // Defaults from translations if not provided
  const seoTitle = title || t("seo.title.home" as any);
  const seoDescription = description || t("seo.description.home" as any);
  const seoKeywords = keywords || t("seo.keywords.home" as any);
  const seoImage = image || `${domain}/og-image.png`;

  const localeMap = {
    pl: "pl_PL",
    en: "en_US",
    de: "de_DE"
  };

  return (
    <Head>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="author" content="Gendera Service" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:locale" content={localeMap[language]} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Head>
  );
};

export default SeoMetadata;
